import urlSlug from 'url-slug'

export function slugify(str: string): string {
  return urlSlug(str) || '-'
}
